module.exports = __webpack_public_path__ + "static/media/logo_transparent_red.68bf579d.png";